import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch, Route } from 'react-router-dom';
import { IHasPageChangeRef } from '../../../../../../../main/interface/has-page-change';
import { useSetFourthLevelRoute } from '../../../../../../hooks/use-set-fourth-level-route';
import DocumentList from './document-list';

interface IMatch {
  path: string;
  params: {
    thirdLevelRoute: string;
  }
}

interface IDocumentListProps {
  type: string;
  hasPageChangeRef: React.MutableRefObject<IHasPageChangeRef>;
}

class DocumentsList {

  name = 'reports-layout';

  render: React.FC<IDocumentListProps> = (props) => {
    const match: IMatch = useRouteMatch();
    const dispatch = useDispatch();

    useSetFourthLevelRoute({
      dispatch,
      mainRoute: 'admin',
      subRoute: 'business-process',
      thirdLevelRoute: match.params.thirdLevelRoute,
      fourthLevelRoute: this.name,
      currentRoute: this.name
    });

    return (
      <>
        <Route path={`${match.path}`} exact>
          <DocumentList hasPageChangeRef={props.hasPageChangeRef} />
        </Route>
      </>
    );
  }
}

export default DocumentsList;
